import Component from "./wrapper"
import Context from "./context"
import Header from "./header"

export default {
  Component,
  Context,
  Header,
}
